import React from "react";
import {
  Button,
  ContainerForm,
  ContainerText,
  Input,
  TextHead,
  TextRegular,
} from "./CardInfo.styled";
import { func } from "../../../../utils";
import { useLocation, useNavigate } from "react-router-dom";

const CardInfo = ({ city }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const actionWording = location?.state?.action ?? "registrasi";
  const isRegistration = actionWording === "registrasi";

  const handleClick = () => {
    navigate("/");
  };

  return (
    <div className="flex flex-col items-center justify-center gap-[55px]">
      <ContainerForm>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <ContainerText>
            <img
              src={func.getStaticImg("/illustration/warning-icon.svg")}
              alt="success-regist"
              style={{ width: 53, height: 53 }}
            />
            <div>
              <TextRegular
                fontSize={"16px"}
                style={{ fontWeight: "bold", marginBottom: 8 }}
              >
                Bukti Pembayaran Sedang Dikonfirmasi
              </TextRegular>
              <TextRegular fontSize="12px" className="mt-2">
                Konfirmasi status pembayaran dapat dilihat di Dashboard
              </TextRegular>
            </div>
          </ContainerText>
        </div>
      </ContainerForm>
      <Button onClick={handleClick}>Lihat Dashboard</Button>
    </div>
  );
};

export default CardInfo;
